import React from 'react';
import './ProductStyle.css';

const BrightWire = ({ open,onClose }) => {
    

    if(!open) return null
    return (
        <div className='overlay'>
            <div className='proContainer'>
                <button onClick={onClose} className='closeBtn'>X</button>
                <p> Bright Wire</p>
                <div className='specs'>
                    <ul>
                        <li>Raw Material: <div>Low Carbon steel, High Carbon steel</div></li>
                        <li>Dimensions Range: <div>⌀1mm - ⌀13mm</div></li>
                        <li>Surface Quality: <div>Bright suitable for enamel, nickel plating, galvanizing or painting</div></li>
                        <li>Packing: <div>Spools (300kg - 1000kg), Coils (100kg - 500kg), Straightened bars  </div></li>
                        <li>Applications:<div>Nickel plating</div></li>
                    </ul>
                </div>
                
            </div>
        </div>


    );
}

export default BrightWire;
